import CampaignInfo from './CampaignInfo'

export default CampaignInfo
